import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { TooltipContent } from '../TooltipContent';
import { TooltipButton } from 'common/react/components/tooltip-button';
import { SvgIcon } from 'common/react/components/SvgIcon';
import { getTranslation } from 'common/react/utils/translations';

const MAX_ITEMS = 5;

export const BodyCellForm = ({ cell, cellProps }) => {
    const formList = useMemo(() => {
        if (cell?.value) {
            const formLetters = cell.value.split('');

            // converting form letters into objects with match index
            const formObjects = [];
            let matchesInForm = 0;
            formLetters
                .slice(-MAX_ITEMS)
                .reverse()
                .forEach((formLetter) => {
                    const matchObject = { letter: formLetter };
                    matchObject.matchIndex = matchesInForm;
                    matchesInForm++;
                    formObjects.push(matchObject);
                });

            formObjects.reverse();

            while (formObjects.length < MAX_ITEMS) {
                formObjects.push({ letter: '-' });
            }

            return formObjects;
        }

        return [];
    }, [cell]);

    const hideArrow = isMobile ? true : false;
    const showOnHover = isMobile ? false : true;

    const teamId = cell?.row?.original?.club?.id;

    return (
        <td
            {...cellProps}
            className="stats-table__cell stats-table__cell--form"
        >
            <ul className="stats-table__form">
                {formList.map((formObj, index) => (
                    <li
                        key={`team-${teamId}-form-${index}`}
                        className={`stats-table__form-item stats-table__form-item--${formObj.letter.toLowerCase()}`}
                    >
                        {formObj.letter === '-' || formObj.letter === 'B' ? (
                            <>
                                {formObj.letter === '-' && (
                                    <span>{formObj.letter}</span>
                                )}
                                {formObj.letter === 'B' && (
                                    <SvgIcon
                                        icon="ladder-form-icon-b"
                                        className="icon"
                                    />
                                )}
                            </>
                        ) : (
                            <TooltipButton
                                id={`ladder-tooltip-${teamId}-${formObj.matchIndex.toString()}`}
                                title={getTranslation(
                                    'label.ladder.tooltipTitle'
                                )}
                                classNames={{
                                    component: 'ladder-tooltip__tooltip',
                                    button: 'ladder-tooltip__trigger'
                                }}
                                direction="below"
                                primaryTooltipContent={
                                    <TooltipContent
                                        cell={cell}
                                        formStringIndex={formObj.matchIndex.toString()}
                                    />
                                }
                                showOnHover={showOnHover}
                                noPadding
                                externalTooltip={true}
                                hideArrow={hideArrow}
                                tooltipPadding={0}
                            >
                                <SvgIcon
                                    icon={`ladder-form-icon-${formObj.letter.toLowerCase()}`}
                                    className="icon"
                                />
                            </TooltipButton>
                        )}
                    </li>
                ))}
            </ul>
        </td>
    );
};

BodyCellForm.propTypes = {
    cell: PropTypes.object,
    cellProps: PropTypes.object
};
